export enum ElementTypeEnum {
  TEXT = "text",
  SELECT = "select",
  RADIO = "radio",
  CHECK = "check",
  GROUP = "group",
  TEXTAREA = "textarea",
  FETCH = "fetch",
  MESSAGE = "message",
  BUTTON = "button",
};
export const FormElementType = {
  TEXT: ElementTypeEnum.TEXT,
  SELECT: ElementTypeEnum.SELECT,
  RADIO: ElementTypeEnum.RADIO,
  CHECK: ElementTypeEnum.CHECK,
  GROUP: ElementTypeEnum.GROUP,
  TEXTAREA: ElementTypeEnum.TEXTAREA,
} as const;
export type FormElementType = typeof FormElementType[keyof typeof FormElementType];

export const ValidationElementType = {
  FETCH: ElementTypeEnum.FETCH,
  ...FormElementType
}
export type ValidationElementType = typeof ValidationElementType[keyof typeof ValidationElementType];

export const ElementType = {
  MESSAGE: ElementTypeEnum.MESSAGE,
  BUTTON: ElementTypeEnum.BUTTON,
  ...ValidationElementType
} as const;
export type ElementType = typeof ElementType[keyof typeof ElementType];

